import React from 'react';
import { useShowContext } from 'ui-builder';
import { get } from 'lodash';
import BaseFieldProps from './BaseFieldProps';
import DOMPurify from 'dompurify';

export default function TextWithLinksField(props: BaseFieldProps) {
  const context = useShowContext();

  let result;

  if (props.source) {
    if (context.data) {
      result = get(context.data, props.source) ?? '-';
    } else {
      result = '-';
    }
  } else {
    result = props.value;
  }

  // escape HTML
  result = DOMPurify.sanitize(result);
  result = result.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  result = result.replace(/(https?:\/\/[^\s]+\.[A-Za-z]+)/g, '<a href="$1" target="_blank">$1</a>');
  result = result.replace(/(^|[^/])(www\.[\S]+(\b|$))/g, '$1<a href="http://$2" target="_blank">$2</a>');


  return (
    <span className={props.className} dangerouslySetInnerHTML={{__html: result}} />
  );
}
